var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Office',{attrs:{"filename":_vm.filename,"fileid":_vm.fileid,"has-preview":_vm.hasPreview,"source":_vm.source,"mime":_vm.mime,"permissions":_vm.permissions,"is-embedded":_vm.isEmbedded},on:{"close":function($event){return _vm.$parent.close()},"update:loaded":function($event){return _vm.$emit('update:loaded', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }